
import Vue from "vue";
import { NewCompanyUsersApiFunc, setAccessToken } from "@/api";
import { CompanyUser } from "@/models";

import CompanyUserList from "./components/CompanyUserList.vue";
import SearchForm from "@/components/BaseSearchForm.vue";
import Pager from "@/components/BasePager.vue";
import TheTemplate from "../TheTemplate.vue";

export type FilterCondition = {
  word?: string;
};

export type DataType = {
  companyUsers: Array<CompanyUser>;
  filterCondition: FilterCondition;
  totalPage: number;
  currentPage: number;
};

export default Vue.extend({
  name: "CompanyUserListScreen",

  data(): DataType {
    return {
      companyUsers: [],
      filterCondition: {
        word: "",
      },
      totalPage: 0,
      currentPage: 0,
    };
  },

  mounted() {
    this.fetchCompanyUsers();
  },

  watch: {
    $route(to, from) {
      if (to.params.updated === "true") {
        this.fetchCompanyUsers(this.currentPage);
      }
    },
  },

  components: {
    TheTemplate,
    SearchForm,
    CompanyUserList,
    Pager,
  },

  methods: {
    async fetchCompanyUsers(page?: number): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const filterString: string = JSON.stringify({
        q: this.filterCondition.word,
      });
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewCompanyUsersApiFunc().listCompanyUsers(
        companyId,
        filterString,
        page
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchCompanyUsers(page);
        });
        return;
      }

      this.companyUsers = data.list;
      this.currentPage = data.currentPage;
      this.totalPage = data.totalPage;
    },

    changePage(page: number): void {
      this.fetchCompanyUsers(page);
    },
  },
});
